var commentRegex = require("comment-regex");
let {
  RenderPass
} = require("./libs/RenderPass.js");
let {
  CopyShader
} = require("./libs/CopyShader.js");
module.exports = function (THREE) {
  THREE.RenderPass = RenderPass;
  THREE.CopyShader = CopyShader;
  THREE.StrippedLambertMaterial = function (p7652) {
    let v6397 = new THREE.ShaderMaterial({
      name: "lambert-stripped",
      uniforms: THREE.UniformsUtils.merge([THREE.ShaderLib.lambert.uniforms]),
      lights: true,
      fog: true,
      vertexShader: "\n\t\t\t\t#define LAMBERT\n\t\t\t\tvarying vec3 vLightFront;\n\t\t\t\tvarying vec3 vIndirectFront;\n\t\t\t\t#ifdef DOUBLE_SIDED\n\t\t\t\t\tvarying vec3 vLightBack;\n\t\t\t\t\tvarying vec3 vIndirectBack;\n\t\t\t\t#endif\n\t\t\t\t#include <common>\n\t\t\t\t#include <uv_pars_vertex>\n\t\t\t\t#include <uv2_pars_vertex>\n\t\t\t\t// #include <envmap_pars_vertex>\n\t\t\t\t#include <bsdfs>\n\t\t\t\t#include <lights_pars_begin>\n\t\t\t\t#include <color_pars_vertex>\n\t\t\t\t#include <fog_pars_vertex>\n\t\t\t\t// #include <morphtarget_pars_vertex>\n\t\t\t\t// #include <skinning_pars_vertex>\n\t\t\t\t#include <shadowmap_pars_vertex>\n\t\t\t\t// #include <logdepthbuf_pars_vertex>\n\t\t\t\t// #include <clipping_planes_pars_vertex>\n\t\t\t\tvoid main() {\n\t\t\t\t\t#include <uv_vertex>\n\t\t\t\t\t#include <uv2_vertex>\n\t\t\t\t\t#include <color_vertex>\n\t\t\t\t\t#include <beginnormal_vertex>\n\t\t\t\t\t// #include <morphnormal_vertex>\n\t\t\t\t\t// #include <skinbase_vertex>\n\t\t\t\t\t// #include <skinnormal_vertex>\n\t\t\t\t\t#include <defaultnormal_vertex>\n\t\t\t\t\t#include <begin_vertex>\n\t\t\t\t\t// #include <morphtarget_vertex>\n\t\t\t\t\t// #include <skinning_vertex>\n\t\t\t\t\t#include <project_vertex>\n\t\t\t\t\t// #include <logdepthbuf_vertex>\n\t\t\t\t\t// #include <clipping_planes_vertex>\n\t\t\t\t\t#include <worldpos_vertex>\n\t\t\t\t\t// #include <envmap_vertex>\n\t\t\t\t\t#include <lights_lambert_vertex>\n\t\t\t\t\t#include <shadowmap_vertex>\n\t\t\t\t\t#include <fog_vertex>\n\t\t\t\t}\n\t\t\t\t",
      fragmentShader: "\n\t\t\t\tuniform vec3 diffuse;\n\t\t\t\tuniform vec3 emissive;\n\t\t\t\tuniform float opacity;\n\n\t\t\t\tvarying vec3 vLightFront;\n\t\t\t\tvarying vec3 vIndirectFront;\n\n\t\t\t\t#ifdef DOUBLE_SIDED\n\t\t\t\t\tvarying vec3 vLightBack;\n\t\t\t\t\tvarying vec3 vIndirectBack;\n\t\t\t\t#endif\n\n\n\t\t\t\t#include <common>\n\t\t\t\t#include <packing>\n\t\t\t\t// #include <dithering_pars_fragment>\n\t\t\t\t#include <color_pars_fragment>\n\t\t\t\t#include <uv_pars_fragment>\n\t\t\t\t#include <uv2_pars_fragment>\n\t\t\t\t#include <map_pars_fragment>\n\t\t\t\t// #include <alphamap_pars_fragment>\n\t\t\t\t#include <aomap_pars_fragment>\n\t\t\t\t#include <lightmap_pars_fragment>\n\t\t\t\t#include <emissivemap_pars_fragment>\n\t\t\t\t// #include <envmap_pars_fragment>\n\t\t\t\t#include <bsdfs>  // Shading functions\n\t\t\t\t#include <lights_pars_begin>\n\t\t\t\t#include <fog_pars_fragment>\n\t\t\t\t#include <shadowmap_pars_fragment>\n\t\t\t\t#include <shadowmask_pars_fragment>\n\t\t\t\t// #include <specularmap_pars_fragment>\n\t\t\t\t// #include <logdepthbuf_pars_fragment>\n\t\t\t\t// #include <clipping_planes_pars_fragment>\n\n\t\t\t\tvoid main() {\n\n\t\t\t\t\t// #include <clipping_planes_fragment>\n\n\t\t\t\t\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t\t\t\t\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\t\t\t\t\tvec3 totalEmissiveRadiance = emissive;\n\n\t\t\t\t\t// #include <logdepthbuf_fragment>\n\t\t\t\t\t#include <map_fragment>\n\t\t\t\t\t#include <color_fragment>\n\t\t\t\t\t// #include <alphamap_fragment>\n\t\t\t\t\t#include <alphatest_fragment>\n\t\t\t\t\t// #include <specularmap_fragment>\n\t\t\t\t\t#include <emissivemap_fragment>\n\n\t\t\t\t\t// accumulation\n\t\t\t\t\treflectedLight.indirectDiffuse = getAmbientLightIrradiance( ambientLightColor );\n\n\t\t\t\t\t#ifdef DOUBLE_SIDED\n\n\t\t\t\t\t\treflectedLight.indirectDiffuse += ( gl_FrontFacing ) ? vIndirectFront : vIndirectBack;\n\n\t\t\t\t\t#else\n\n\t\t\t\t\t\treflectedLight.indirectDiffuse += vIndirectFront;\n\n\t\t\t\t\t#endif\n\n\t\t\t\t\t#include <lightmap_fragment>\n\n\t\t\t\t\treflectedLight.indirectDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb );\n\n\t\t\t\t\t#ifdef DOUBLE_SIDED\n\n\t\t\t\t\t\treflectedLight.directDiffuse = ( gl_FrontFacing ) ? vLightFront : vLightBack;\n\n\t\t\t\t\t#else\n\n\t\t\t\t\t\treflectedLight.directDiffuse = vLightFront;\n\n\t\t\t\t\t#endif\n\n\t\t\t\t\treflectedLight.directDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb ) * getShadowMask();\n\n\t\t\t\t\t// modulation\n\t\t\t\t\t#include <aomap_fragment>\n\n\t\t\t\t\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\n\t\t\t\t\t// #include <envmap_fragment>\n\n\t\t\t\t\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\n\t\t\t\t\t// #include <tonemapping_fragment>\n\t\t\t\t\t// #include <encodings_fragment>\n\t\t\t\t\t#include <fog_fragment>\n\t\t\t\t\t#include <premultiplied_alpha_fragment>\n\t\t\t\t\t// #include <dithering_fragment>\n\t\t\t\t}\n\t\t\t\t\t"
    });
    Object.assign(v6397, new THREE.MeshLambertMaterial(p7652));
    v6397.isMeshLambertMaterial = true;
    v6397.setValues(p7652);
    return v6397;
  };
  THREE.EffectComposer = function (p7653, p7654, p7655) {
    this.renderer = p7653;
    if (p7654 === undefined) {
      var vO184 = {
        minFilter: THREE.LinearFilter,
        magFilter: THREE.LinearFilter,
        format: THREE.RGBAFormat
      };
      var v6398 = p7653.getSize(new THREE.Vector2());
      this._pixelRatio = p7653.getPixelRatio();
      this._width = v6398.width;
      this._height = v6398.height;
      p7654 = new THREE.WebGLRenderTarget(this._width * this._pixelRatio, this._height * this._pixelRatio, vO184);
      p7654.texture.name = "EffectComposer.rt1";
    } else {
      this._pixelRatio = 1;
      this._width = p7654.width;
      this._height = p7654.height;
    }
    this.renderTarget1 = p7654;
    this.renderTarget2 = p7654.clone();
    this.renderTarget2.texture.name = "EffectComposer.rt2";
    this.writeBuffer = this.renderTarget1;
    this.readBuffer = this.renderTarget2;
    this.renderToScreen = true;
    this.RENDER = p7655;
    this.passes = [];
    if (THREE.CopyShader === undefined) {
      console.error("THREE.EffectComposer relies on THREE.CopyShader");
    }
    if (THREE.ShaderPass === undefined) {
      console.error("THREE.EffectComposer relies on THREE.ShaderPass");
    }
    this.copyPass = new THREE.ShaderPass(THREE.CopyShader);
    this.clock = new THREE.Clock();
  };
  Object.assign(THREE.EffectComposer.prototype, {
    swapBuffers: function () {
      var v6399 = this.readBuffer;
      this.readBuffer = this.writeBuffer;
      this.writeBuffer = v6399;
    },
    addPass: function (p7656) {
      this.passes.push(p7656);
      p7656.setSize(this._width * this._pixelRatio, this._height * this._pixelRatio);
    },
    insertPass: function (p7657, p7658) {
      this.passes.splice(p7658, 0, p7657);
      p7657.setSize(this._width * this._pixelRatio, this._height * this._pixelRatio);
    },
    replacePass: function (p7659, p7660) {
      this.passes[p7660] = p7659;
      p7659.setSize(this._width * this._pixelRatio, this._height * this._pixelRatio);
    },
    removePass: function (p7661) {
      const v6400 = this.passes.indexOf(p7661);
      if (v6400 !== -1) {
        this.passes.splice(v6400, 1);
      }
    },
    isLastEnabledPass: function (p7662) {
      for (var v6401 = p7662 + 1; v6401 < this.passes.length; v6401++) {
        if (this.passes[v6401] && this.passes[v6401].enabled) {
          return false;
        }
      }
      return true;
    },
    render: function (p7663 = this.clock.getDelta()) {
      var v6402;
      var v6403;
      var v6404 = this.renderer.getRenderTarget();
      var v6405 = false;
      var v6406 = this.passes.length;
      for (v6403 = 0; v6403 < v6406; v6403++) {
        v6402 = this.passes[v6403];
        if (v6402 && v6402.enabled !== false) {
          v6402.renderToScreen = !v6402.noRTS && this.renderToScreen && this.isLastEnabledPass(v6403);
          v6402.render(this.renderer, this.writeBuffer, this.readBuffer, p7663, v6405, this.RENDER);
          if (v6402.needsSwap) {
            if (v6405) {
              var v6407 = this.renderer.getContext();
              var v6408 = this.renderer.state.buffers.stencil;
              v6408.setFunc(v6407.NOTEQUAL, 1, 4294967295);
              this.copyPass.render(this.renderer, this.writeBuffer, this.readBuffer, p7663);
              v6408.setFunc(v6407.EQUAL, 1, 4294967295);
            }
            this.swapBuffers();
          }
          if (THREE.MaskPass !== undefined) {
            if (v6402 instanceof THREE.MaskPass) {
              v6405 = true;
            } else if (v6402 instanceof THREE.ClearMaskPass) {
              v6405 = false;
            }
          }
        }
      }
      this.renderer.setRenderTarget(v6404);
    },
    reset: function (p7664) {
      if (p7664 === undefined) {
        var v6409 = this.renderer.getSize(new THREE.Vector2());
        this._pixelRatio = this.renderer.getPixelRatio();
        this._width = v6409.width;
        this._height = v6409.height;
        p7664 = this.renderTarget1.clone();
        p7664.setSize(this._width * this._pixelRatio, this._height * this._pixelRatio);
      }
      this.renderTarget1.dispose();
      this.renderTarget2.dispose();
      this.renderTarget1 = p7664;
      this.renderTarget2 = p7664.clone();
      this.writeBuffer = this.renderTarget1;
      this.readBuffer = this.renderTarget2;
    },
    setSize: function (p7665, p7666) {
      this._width = p7665;
      this._height = p7666;
      var v6410 = this._width * this._pixelRatio;
      var v6411 = this._height * this._pixelRatio;
      this.renderTarget1.setSize(v6410, v6411);
      this.renderTarget2.setSize(v6410, v6411);
      for (var vLN01026 = 0; vLN01026 < this.passes.length; vLN01026++) {
        if (this.passes[vLN01026]) {
          this.passes[vLN01026].setSize(v6410, v6411);
        }
      }
    },
    setPixelRatio: function (p7667) {
      this._pixelRatio = p7667;
      this.setSize(this._width, this._height);
    }
  });
  THREE.Pass = function () {
    this.enabled = true;
    this.needsSwap = true;
    this.clear = false;
    this.renderToScreen = false;
  };
  Object.assign(THREE.Pass.prototype, {
    setSize: function () {},
    render: function () {
      console.error("THREE.Pass: .render() must be implemented in derived pass.");
    }
  });
  THREE.Pass.FullScreenQuad = function () {
    var v6412 = new THREE.OrthographicCamera(-1, 1, 1, -1, 0, 1);
    var v6413 = new THREE.BufferGeometry();
    const v6414 = new Float32Array([-1, 3, 0, -1, -1, 0, 3, -1, 0]);
    v6413.setAttribute("position", new THREE.BufferAttribute(v6414, 3));
    const v6415 = new Float32Array([0, 2, 0, 0, 2, 0]);
    v6413.setAttribute("uv", new THREE.BufferAttribute(v6415, 2));
    function f1131(p7668) {
      this._mesh = new THREE.Mesh(v6413, p7668);
    }
    Object.defineProperty(f1131.prototype, "material", {
      get: function () {
        return this._mesh.material;
      },
      set: function (p7669) {
        this._mesh.material = p7669;
      }
    });
    Object.assign(f1131.prototype, {
      dispose: function () {
        this._mesh.geometry.dispose();
      },
      render: function (p7670) {
        p7670.render(this._mesh, v6412);
      }
    });
    return f1131;
  }();
  THREE.ShaderPass = function (p7671, p7672) {
    THREE.Pass.call(this);
    this.textureID = p7672 === undefined ? "tDiffuse" : p7672;
    if (p7671 instanceof THREE.ShaderMaterial) {
      this.uniforms = p7671.uniforms;
      this.material = p7671;
    } else if (p7671) {
      this.uniforms = THREE.UniformsUtils.clone(p7671.uniforms);
      this.material = new THREE.ShaderMaterial({
        defines: Object.assign({}, p7671.defines),
        uniforms: this.uniforms,
        vertexShader: p7671.vertexShader,
        fragmentShader: p7671.fragmentShader
      });
    }
    if (this.material) {
      this.material.transparent = true;
    }
    this.clock = new THREE.Clock();
    this.fsQuad = new THREE.Pass.FullScreenQuad(this.material);
  };
  THREE.ShaderPass.prototype = Object.assign(Object.create(THREE.Pass.prototype), {
    constructor: THREE.ShaderPass,
    render: function (p7673, p7674, p7675, p7676, p7677, p7678) {
      if (this.uniforms[this.textureID]) {
        this.uniforms[this.textureID].value = p7675.texture;
      }
      if (this.uniforms.time == null) {
        this.uniforms.time = {
          type: "1f",
          value: this.clock.getElapsedTime()
        };
      } else {
        this.uniforms.time.value = this.clock.getElapsedTime();
      }
      if (this.uniforms.delta == null) {
        this.uniforms.delta = {
          type: "1f",
          value: p7676
        };
      } else {
        this.uniforms.delta.value = p7676;
      }
      if (this.uniforms.mouse == null) {
        this.uniforms.mouse = {
          value: p7678.tmpMouse
        };
      } else {
        this.uniforms.mouse.value = p7678.tmpMouse;
      }
      if (this.uniforms.frame == null) {
        this.uniforms.frame = {
          value: 1
        };
      } else {
        this.uniforms.frame.value++;
      }
      this.fsQuad.material = this.material;
      if (this.renderToScreen) {
        p7673.setRenderTarget(null);
        this.fsQuad.render(p7673);
      } else {
        p7673.setRenderTarget(p7674);
        if (this.clear) {
          p7673.clear(p7673.autoClearColor, p7673.autoClearDepth, p7673.autoClearStencil);
        }
        this.fsQuad.render(p7673);
      }
    }
  });
  class C240 extends THREE.RawShaderMaterial {
    constructor(p7679, p7680) {
      var v6416 = p7680 || {};
      v6416.aspectRatio = v6416.aspectRatio || 2;
      let vLN1500 = 1500;
      let v6417 = vLN1500 / v6416.aspectRatio;
      v6416.width = vLN1500;
      v6416.hieght = v6417;
      let v6418 = C240.retriveUsedUniforms(p7679);
      var v6419 = new THREE.Clock();
      super({
        vertexShader: "\n\t\tattribute vec3 position;\n\t\tattribute vec2 uv;\n\t\tuniform mat4 projectionMatrix;\n\t\tuniform mat4 modelViewMatrix;\n\t\tvarying vec2 vUv;\n\t\tvoid main () {\n\t\t\tgl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);\n\t\t\tvUv=uv;\n\t\t}\n\t",
        fragmentShader: ""
      });
      if (v6418.iTime || v6418.iTimeDelta || v6418.iFrame || v6418.iDate) {
        if (v6418.iTime || v6418.iTimeDelta) {
          this.clock = v6419;
        }
        this.registerUpdate();
      }
      let v6420 = this.createUniformsObject(v6418, v6416);
      this.uniforms = v6420.prof;
      var v6421 = "\n\t\tprecision highp float;\n\t\tuniform vec2 iResolution;\n\t\tvarying vec2 vUv;\n\t\tvec4 texture(sampler2D sampler, vec2 coord){\n\t\t\treturn texture2D(sampler,  coord);\n\t\t}\n\t\tvoid  mainImage( out vec4,  vec2 fragCoord );\n\t\tvoid main () {\n\t\t\tvec4 outfrag;\n\t\t\tmainImage(outfrag,iResolution*vUv);\n\t\t\tgl_FragColor = outfrag;\n\t\t}\n\t\n" + v6420.code + "\n" + p7679;
      this.fragmentShader = v6421;
    }
    registerUpdate() {
      requestAnimationFrame(() => this.update(), 0);
    }
    update() {
      if (this.uniforms.iTime) {
        this.uniforms.iTime.value = this.clock.getElapsedTime();
      }
      if (this.uniforms.iTimeDelta) {
        this.uniforms.iTimeDelta.value = this.clock.getDelta();
      }
      if (this.uniforms.iFrame) {
        ++this.uniforms.iFrame.value;
      }
      if (this.uniforms.iDate) {
        let v6422 = new Date();
        let v6423 = v6422.getSeconds() + v6422.getMinutes() * 60 + v6422.getHours() * 3600;
        this.uniforms.iDate.value = new THREE.Vector4(v6422.getFullYear(), v6422.getMonth(), v6422.getDay(), v6423);
      }
      if (this.uniforms.iChannelResolution) {
        let vF49 = p7681 => {
          if (this.uniforms["iChannel" + p7681] && this.uniforms["iChannel" + p7681].value.image) {
            this.uniforms.iChannelResolution.value[p7681] = new THREE.Vector3(this.uniforms["iChannel" + p7681].value.image.width, this.uniforms["iChannel" + p7681].value.image.height);
          }
        };
        for (let vLN01027 = 0; vLN01027 < 4; vLN01027++) {
          vF49(vLN01027);
        }
      }
      requestAnimationFrame(() => {
        this.update();
      });
    }
    static retriveUsedUniforms(p7682) {
      let v6424 = p7682.replace(commentRegex(), "");
      let v6425 = "iTime,iTimeDelta,iResolution,iFrame,iChannelTime[4],iChannelResolution,iChannel0,iChannel1,iChannel2,iChannel3,iDate,iMouse".split(",");
      let vO185 = {};
      v6425.forEach(p7683 => {
        if (v6424.includes(p7683)) {
          vO185[p7683] = true;
        }
      });
      return vO185;
    }
    createUniformsObject(p7684, p7685) {
      function f1132(p7686) {
        if (p7684["iChannel" + p7686]) {
          let v6426 = p7685.map ? p7685.map : null;
          v6426 = Array.isArray(v6426) ? v6426[p7686] : v6426;
          vO186["iChannel" + p7686] = {
            type: "t",
            value: v6426
          };
          vLS21 += "uniform sampler2D " + ["iChannel" + p7686] + ";\n";
        }
      }
      let vO186 = {};
      let vLS21 = "";
      if (p7684.iResolution) {
        vO186.iResolution = {
          value: new THREE.Vector2(p7685.width, p7685.hieght)
        };
      }
      if (p7684.iTime) {
        vO186.iTime = {
          type: "1f",
          value: this.clock.getElapsedTime()
        };
        vLS21 += "uniform float iTime;\n";
      }
      if (p7684.iDate) {
        vO186.iDate = {
          value: new THREE.Vector4()
        };
        vLS21 += "uniform vec4 iDate;\n";
      }
      if (p7684.iTimeDelta) {
        vO186.iTimeDelta = {
          type: "1f",
          value: this.clock.getDelta()
        };
        vLS21 += "uniform float iTimeDelta;\n";
      }
      if (p7684.iFrame) {
        vO186.iFrame = {
          type: "1i",
          value: 0
        };
        vLS21 += "uniform int iFrame;\n";
      }
      if (p7684.iMouse) {
        vO186.iMouse = {
          value: new THREE.Vector4(p7685.width / 2, p7685.hieght / 2, p7685.width / 2, p7685.hieght / 2)
        };
        vLS21 += "uniform vec4 iMouse;\n";
      }
      if (p7684.iChannelResolution) {
        vO186.iChannelResolution = {
          type: "v3v",
          value: [new THREE.Vector3(), new THREE.Vector3(), new THREE.Vector3(), new THREE.Vector3()]
        };
        vLS21 += "uniform vec3 iChannelResolution[4];\n";
      }
      for (let vLN01028 = 0; vLN01028 < 4; vLN01028++) {
        f1132(vLN01028);
      }
      return {
        prof: vO186,
        code: vLS21
      };
    }
  }
  THREE.ShaderToyMaterial = C240;
};